var _path, _line, _path2, _path3, _line2, _line3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRightTurn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 299,
    height: 267,
    viewBox: "0 0 299 267",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M149.5 267C169.133 267 188.573 263.547 206.711 256.838C224.849 250.129 241.33 240.295 255.212 227.899C269.095 215.502 280.107 200.785 287.62 184.588C295.133 168.391 299 151.031 299 133.5C299 115.969 295.133 98.6087 287.62 82.4118C280.107 66.2148 269.095 51.4979 255.212 39.1012C241.33 26.7046 224.849 16.8711 206.711 10.1621C188.573 3.45308 169.133 -1.53265e-06 149.5 0L149.5 66.75C159.316 66.75 169.036 68.4765 178.106 71.831C187.175 75.1855 195.415 80.1023 202.356 86.3006C209.297 92.4989 214.803 99.8574 218.56 107.956C222.317 116.054 224.25 124.734 224.25 133.5C224.25 142.266 222.317 150.946 218.56 159.044C214.803 167.143 209.297 174.501 202.356 180.699C195.415 186.898 187.175 191.814 178.106 195.169C169.036 198.523 159.316 200.25 149.5 200.25V267Z",
    fill: "#222020"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 106,
    y1: 31.5,
    x2: 159,
    y2: 31.5,
    stroke: "white",
    strokeWidth: 5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M202 45.7361C202 45.7361 218.568 51.2064 226.921 58.1734C234.88 64.8118 243.076 79.2285 243.076 79.2285",
    stroke: "white",
    strokeWidth: 5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M202 220.492C202 220.492 218.568 215.022 226.921 208.055C234.88 201.417 243.076 187 243.076 187",
    stroke: "white",
    strokeWidth: 5
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 260.5,
    y1: 158,
    x2: 260.5,
    y2: 105,
    stroke: "white",
    strokeWidth: 5
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 106,
    y1: 231.5,
    x2: 159,
    y2: 231.5,
    stroke: "white",
    strokeWidth: 5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightTurn);
export default __webpack_public_path__ + "static/media/right-turn.9a9b91c9d7956d0fcafe8661f695612c.svg";
export { ForwardRef as ReactComponent };